import React, {useRef} from 'react';

import styled from 'styled-components';

import {Minus} from '@styled-icons/heroicons-outline/Minus';
import {Check} from '@styled-icons/heroicons-outline/Check';

import theme from '@bootcamp/shared/src/styles/theme';


export const Label = styled.label`
  cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({disabled}) => disabled ? '0.5' : '1'};
  padding: 6px 8px;
`;
export const CustomInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({size}) => size}px;
  height: ${({size}) => size}px;
  min-width: ${({size}) => size}px;
  min-height: ${({size}) => size}px;
  border-radius: 2px;
  cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
  border: 1px solid ${({theme, checked, disabled, locked}) => ((checked && !disabled) || locked) ? 'none' : theme.colors.neutralsPalette.lightGrey};
  background: ${({checked, disabled, theme, customTheme}) => disabled
    ? theme.colors.neutralsPalette.extraLight
    : checked && customTheme.default == '#EDEDF0' ? '#85868E'
    : checked
    ? customTheme.default || customTheme.dark
    : 'white'
  };
`;
export const InputWrapper = styled.label`
  display: flex;
  /* align-items: center; */
  cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
`;
export const InputCheck = styled(Check)`
  width: ${({size}) => size - 6}px;
  height: ${({size}) => size - 6}px;
  color: white;
  path {
    stroke-width: 4px;
  }
`;
export const InputMinus = styled(Minus)`
  width: 12px;
  height: 12px;
  color: ${({customTheme}) => customTheme.default};
  path {
    stroke-width: 4px;
  }
`;
export const InputHoverWrapper = styled.div`
  display: flex;

  &:hover {
    ${CustomInputWrapper} {
      background: ${({theme, active, disabled}) => !active && !disabled && theme.colors.neutralsPalette.light};
    }
  }
`;

export const Input = styled.input`
  margin: 0;
  cursor: pointer;

  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;

export const InputComponent = ({
  className,
  checked,
  name,
  free,
  value,
  loading,
  containerRef,
  locked,
  children,
  tabIndex=0,
  size=18,
  clickDisabled,
  onClick = () => {},
  customTheme=theme.colors.brandPalette.blue
}) => {
  const ref = useRef();

  const disabled = loading || locked;

  const handleClick = (e) => {
    if (disabled || clickDisabled) return;
    e.stopPropagation();
    e.preventDefault();
    onClick(e);
  };

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };

  return (
    <InputWrapper
      className={className}
      ref={containerRef}
      htmlFor={value}
      disabled={disabled}
      onClick={handleClick}
    >
      <InputHoverWrapper active={checked} disabled={disabled} tabIndex={-1}>
        <CustomInputWrapper
          htmlFor={value}
          checked={checked}
          disabled={disabled}
          locked={locked}
          tabIndex={disabled ? -1 : tabIndex} // Make focusable if not disabled
          role="checkbox" // Accessible role
          aria-checked={checked} // State of the checkbox
          onKeyDown={handleKeyDown} // Handle keyboard interactions
          size={size}
          customTheme={customTheme}
        >
          <Input
            ref={ref}
            id={value}
            type={'checkbox'}
            checked={checked}
            disabled={disabled}
            value={value}
            tabIndex={-1}
          />
          {!!checked && <InputCheck data-input-element size={size}/>}
        </CustomInputWrapper>
        {children}
      </InputHoverWrapper>
    </InputWrapper>
  );
};